import { get } from "./api_helper";
import * as url from "./url_helper";


// get orders
export const getMyOrdersEndpoint = () =>
  get(`${url.GET_MY_ORDERS}`);